<template>
  <div class="relative">
    <label class="sr-only" for="sorter">{{ t('materials.sort') }}</label>
    <button
      id="sorter"
      type="button"
      class="inline-flex items-center gap-2 rounded-full bg-[#EEDCC5] px-4 py-2 text-sm font-medium hover:bg-[#e7d8c8] focus:outline-none focus:ring-0"
      @click="open = !open"
    >
      <span class="text-neutral-700">{{ t('materials.sort') }}: {{ currentLabel }}</span>
      <svg viewBox="0 0 20 20" fill="currentColor" :class="['h-4 w-4 transition-transform duration-200', open ? 'rotate-180' : '']"><path fill-rule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 10.94l3.71-3.71a.75.75 0 111.06 1.06l-4.24 4.24a.75.75 0 01-1.06 0L5.21 8.29a.75.75 0 01.02-1.08z" clip-rule="evenodd"/></svg>
    </button>
    <div v-if="open" class="absolute right-0 z-50 mt-2 w-56 overflow-hidden rounded-xl bg-[#EEDCC5] shadow-lg">
      <ul class="divide-y divide-[#e7d8c8] text-sm bg-[#EEDCC5]">
        <li v-for="o in options" :key="o.key">
          <button @click="select(o)" class="flex w-full items-center justify-between px-4 py-2 hover:bg-[#e7d8c8] focus:outline-none focus:ring-0">
            <span>{{ o.label }}</span>
            <span v-if="o.key===currentKey" class="text-indigo-600">•</span>
          </button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { t as i18nT } from '../i18n'

const t = (key) => i18nT(key)

const props = defineProps({
  options: { type: Array, default: () => [] },
  currentKey: { type: String, default: '' },
  currentLabel: { type: String, default: '' },
})

const emit = defineEmits(['change'])

const open = ref(false)

function select(o){
  emit('change', o)
  open.value = false
}
</script>
